import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';

const StudentFees = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(true);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [students, setStudents] = useState([]);

  useEffect(() => {
    fetchAllStudentInCourse(id);
  }, [id]);

  const fetchAllStudentInCourse = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/my-course-slip/?enrollmentId=${courseId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        
          setStudents(result?.slips);
        
      })
      .catch((error) => {
        console.error(error);
        toast.error('Failed to fetch students'); // Notify user of error
      })
      .finally(() => {
        setLoader(false); // Stop loading
      });
  };

  const handleChangeStatus = async (newStatus, studentId) => {
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student._id === studentId ? { ...student, isLoading: true } : student
      )
    );

    try {
      const res = await axios.patch(
        `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${studentId}`,
        {
          newStatus: newStatus
        }
      );

      console.log('GAME OF THRONE', res.data);

      if (res.data.success) {
        setStudents((prevStudents) =>
          prevStudents.map((student) =>
            student._id === studentId
              ? { ...student, status: newStatus, isLoading: false }
              : student
          )
        );
      } else {
        console.error(res.data.message);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setStudents((prevStudents) =>
        prevStudents.map((student) =>
          student._id === studentId ? { ...student, isLoading: false } : student
        )
      );
    }
  };

  const ApproveFee = (link) => {
    setIsModelLoading(true);

    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === false) {
          toast.error(data?.error);
          setIsModelLoading(false);
        }
        setIsModelLoading(false);
        toast.success('Fee is Paid');
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error);
        setIsModelLoading(false);
      });
  };

  const closeModal = () => {
    setIsSlipModalOpen(!isSlipModalOpen);
  };

  return (
    <section className="mb-20 mt-7">
      <div className="rounded-lg overflow-x-auto">
        {loader ? ( // Show loader while fetching data
          <Loader />
        ) : students.length > 0 ? ( // Render student list if data is available
          <div className="flex flex-col">
            <div className="sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full mb-0">
                    <thead>
                      <tr className="rounded-lg whitespace-nowrap">
                        <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Slip</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Uploaded Month</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {students.map((student, index) => (
                        <tr
                          key={student?._id}
                          style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                          className="bg-white border-b-8 border-white rounded-md"
                        >
                          {/* ID */}
                          <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {`${index + 1}`}
                            </span>
                          </td>



                        
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                          
                              <a
                                onClick={() => {
                                  setIsSlipModalOpen(true);
                                  setSingleData(student);
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-base text-[#FF7E00] cursor-pointer"
                              >
                                 Fee Slip
                              </a>
                          
                          </td>
                        
                           <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {student?.uploadedMonth}
                            </span>
                          </td>
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                           
                            <span
                              className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${
                                student.status === 'pending'
                                  ? 'bg-[#DFF7E3] text-[#23A118]'
                                  : student.status === 'completed'
                                    ? 'bg-[#FFE4E4] text-[#FF0000]'
                                    : student.status === 'approved'
                                      ? 'bg-[#FFF3E0] text-[#FFA500]'
                                      : student.status === 'inactive'
                                        ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                        : 'bg-gray-200 text-black'
                              }`}
                            >
                              {student.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          
          <div className="text-center py-10">
            <p className="text-gray-500">No students found for this Slips.</p>
          </div>
        )}
      </div>

      {/* Fee Slip Modal */}
      {isSlipModalOpen && (
        <>
          {console.log('GAMe', singleData)}
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={closeModal}
          >
            <div
              className="bg-white p-6 rounded overflow-y-auto h-[60vh] shadow-lg max-w-xl w-full relative"
              onClick={(e) => e.stopPropagation()}
            >
             
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
              >
                ✕
              </button>

              <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

              <div className="w-full mb-6">
                <img
                  src={singleData?.slipUrl}
                  alt="Fee Slip"
                  className="w-full h-auto rounded mb-4"
                />
              </div>

            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default StudentFees;
